import getCountry from './getCountry';
import { toNormaliseErrorInput, type NormaliseErrorInput } from '/shared/functions/normaliseError';

type GetCountryThunk = ReturnType<typeof getCountry>;
type ErrorWithContext = { context: string } & ({ message: string } | { error: NormaliseErrorInput });
type SaveLocationStartedAction = { type: 'SAVE_LOCATION_STARTED'; timestamp: number };
type SaveLocationFulfilledAction = { type: 'SAVE_LOCATION_FULFILLED'; countryCode: string | null };
type SaveLocationRejectedAction = { type: 'SAVE_LOCATION_REJECTED'; error: ErrorWithContext };
type SaveLocationAction = SaveLocationStartedAction | SaveLocationFulfilledAction | SaveLocationRejectedAction;
type SharedDispatch = {
  (action: SaveLocationAction): SaveLocationAction;
  (action: GetCountryThunk): GetCountryThunk;
};

interface SaveLocationOptions {
  countryCode?: string | null;
  token?: string | null;
  useB2BMarkets?: boolean;
}

function withContext(error: NormaliseErrorInput, context: string): ErrorWithContext {
  return error instanceof Error ? { message: error.message, context } : { error, context };
}

const saveLocation =
  ({ countryCode = null, token = null, useB2BMarkets = false }: SaveLocationOptions) =>
  async (dispatch: SharedDispatch): Promise<void> => {
    try {
      dispatch({ type: 'SAVE_LOCATION_STARTED', timestamp: Date.now() });
      dispatch(getCountry({ countryCode, token, useB2BMarkets }));
      dispatch({ type: 'SAVE_LOCATION_FULFILLED', countryCode });
    } catch (error) {
      dispatch({ type: 'SAVE_LOCATION_REJECTED', error: withContext(toNormaliseErrorInput(error), 'LOCATION') });
    }
  };

export default saveLocation;
